import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconExpand45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconExpand45"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3H21V11H19V6.41421L14 11.4142L12.5858 10L17.5858 5H13V3ZM11.4142 14L6.41421 19H11V21H3V13H5V17.5858L10 12.5858L11.4142 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconExpand45;
